import Backbone from "backbone";
import inject from "scripts/ioc/inject";
import BaseModalView from "scripts/views/baseModalView";

import templateCookieSettingsModal from "templates/cookieSettingsModal.hbs";

const chan = Backbone.Radio.channel;

class CookieSettingsModalView extends BaseModalView {
  constructor(
    options,
    googleAnalyticsService = inject("googleAnalyticsService"),
  ) {
    super(options);

    this.googleAnalyticsService = googleAnalyticsService;

    chan("connectionService").on(
      "status:change",
      connectionStatus => {
        if (!connectionStatus.isOnline) {
          this.closeModal();
        }
      },
      this,
    );
  }

  get template() {
    return templateCookieSettingsModal;
  }

  get events() {
    return {
      "click #bb-cookie-settings-modal-confirm": "confirmCookieSettingsClick",
      "click #bb-cookie-settings-analytics": "toggleCookieAnalyticsClick",
    };
  }

  render() {
    this.$el.html(this.template());
    this.renderCookieAnalyticsButton();
    return this;
  }

  renderCookieAnalyticsButton() {
    if (this.googleAnalyticsService.isAnalyticsOptIn()) {
      this.checkCookieAnalyticsButton();
    } else {
      this.unCheckCookieAnalyticsButton();
    }
  }

  toggleCookieAnalyticsClick() {
    if (this.isCookieAnalyticsChecked()) {
      this.unCheckCookieAnalyticsButton();
    } else {
      this.checkCookieAnalyticsButton();
    }
  }

  confirmCookieSettingsClick() {
    this.googleAnalyticsService.setAnalyticsOptIn(
      this.isCookieAnalyticsChecked(),
    );
  }

  isCookieAnalyticsChecked() {
    return (
      this.$el.find("#bb-cookie-settings-analytics.btn-chktoggle-checked")
        .length > 0
    );
  }

  checkCookieAnalyticsButton() {
    this.$el
      .find("#bb-cookie-settings-analytics")
      .removeClass("btn-chktoggle-unchecked")
      .addClass("btn-chktoggle-checked");
  }

  unCheckCookieAnalyticsButton() {
    this.$el
      .find("#bb-cookie-settings-analytics")
      .removeClass("btn-chktoggle-checked")
      .addClass("btn-chktoggle-unchecked");
  }
}

export default CookieSettingsModalView;
